export default __webpack_public_path__ + "./images/hu.2ba1723a.png";